(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvet-circle-cta"] && !Shopify.designMode) return;
  try {
    
/* Upgrades an in-page anchor to a smooth scroll. The link works on its own,
   so this listener never calls preventDefault unless it can do the scroll
   itself, and it stands aside entirely for reduced-motion visitors. */
if (!customElements.get('velvet-circle-scroll')) {
  customElements.define(
    'velvet-circle-scroll',
    class VelvetCircleScroll extends HTMLElement {
      connectedCallback() {
        if (this.dataset.smooth !== 'true' || this.bound) return;
        this.bound = true;
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.bound = false;
      }

      prefersReducedMotion() {
        if (typeof window.matchMedia !== 'function') return false;
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      onClick(event) {
        var link = event.target.closest ? event.target.closest('a[href]') : null;
        if (!link || !this.contains(link)) return;

        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        if (this.prefersReducedMotion()) return;

        var target = document.getElementById(href.slice(1));
        if (!target || typeof target.scrollIntoView !== 'function') return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        var focusTarget = target.querySelector('input, select, textarea, button, a[href]');
        var toFocus = focusTarget || target;
        if (!toFocus.hasAttribute('tabindex') && toFocus === target) {
          toFocus.setAttribute('tabindex', '-1');
        }
        if (typeof toFocus.focus === 'function') {
          toFocus.focus({ preventScroll: true });
        }
        if (window.history && typeof window.history.replaceState === 'function') {
          window.history.replaceState(null, '', href);
        }
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvet-circle-faq"] && !Shopify.designMode) return;
  try {
    
/* Optional accordion behaviour. Native <details> already handles opening,
   closing, keyboard operation and the closed state, so this only adds the
   "close the others" rule when the merchant asks for it. */
if (!customElements.get('velvet-circle-faq')) {
  customElements.define(
    'velvet-circle-faq',
    class VelvetCircleFaq extends HTMLElement {
      connectedCallback() {
        if (this.dataset.accordion !== 'true' || this.bound) return;
        this.bound = true;
        this.onToggle = this.onToggle.bind(this);
        this.addEventListener('toggle', this.onToggle, true);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.onToggle, true);
        this.bound = false;
      }

      onToggle(event) {
        var opened = event.target;
        if (!opened || opened.tagName !== 'DETAILS' || !opened.open) return;
        var items = this.querySelectorAll('details');
        for (var i = 0; i < items.length; i += 1) {
          if (items[i] !== opened) items[i].open = false;
        }
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velvet-circle-form"] && !Shopify.designMode) return;
  try {
    
/* Mirrors the contact-preference checkboxes into the customer[tags] value that
   Shopify's customer form already submits. The form works without this: the
   base tags are present in the hidden input from the server, and every field
   including the checkboxes is a real form control. Without JavaScript the
   preference tags simply are not appended, which is why a consent platform
   app block is the right answer when the preferences must be authoritative. */
if (!customElements.get('velvet-circle-form')) {
  customElements.define(
    'velvet-circle-form',
    class VelvetCircleForm extends HTMLElement {
      connectedCallback() {
        this.tagsInput = this.querySelector('[data-vc-tags]');
        this.preferences = this.querySelectorAll('[data-vc-preference]');
        if (!this.tagsInput || !this.preferences.length || this.bound) return;
        this.bound = true;
        this.onChange = this.onChange.bind(this);
        this.addEventListener('change', this.onChange);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.bound = false;
      }

      onChange(event) {
        if (!event.target.hasAttribute('data-vc-preference')) return;

        var base = this.tagsInput.getAttribute('data-vc-base-tags') || '';
        var tags = base
          .split(',')
          .map(function (tag) { return tag.trim(); })
          .filter(function (tag) { return tag.length > 0; });

        for (var i = 0; i < this.preferences.length; i += 1) {
          var input = this.preferences[i];
          var value = (input.value || '').trim();
          if (input.checked && value && tags.indexOf(value) === -1) tags.push(value);
        }

        this.tagsInput.value = tags.join(', ');
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
